<template>
  <component :is="as" class="option-wrapper" :class="{ selected, disabled, 'has-error': hasError }" v-bind="$attrs">
    <slot />
    <slot name="content" />
  </component>
</template>

<script setup lang="ts">
defineOptions({
  inheritAttrs: false
})

withDefaults(defineProps<{
  as?: string
  selected?: boolean
  disabled?: boolean
  borderRadius?: string
  hasError?: boolean
}>(), {
  as: 'div'
})
</script>

<style lang="scss" scoped>
.option-wrapper {
  border: 1px solid transparent;
  background: transparent;
  border-radius: v-bind(borderRadius);
  cursor: pointer;
  overflow: hidden;

  &:hover:not(.disabled) {
    border-color: $primary-color;
  }

  &.selected {
    border-radius: v-bind(borderRadius);
    border: 1px solid $primary-color;
    outline: 4px solid $primary-color-100;
  }

  &.disabled {
    opacity: 0.55;
    pointer-events: none;
  }

  &.has-error {
    border-color: $error;

    &:hover:not(.disabled) {
      border-color: $error;
    }
  }
}
</style>
